// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"a326328b","994":"7302d596"}[chunkId] + ".chunk.js";
};